import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup } from 'react-bootstrap';
import { Shapes } from '../../models/entities';

const PageSizeSelector = (props) => {
  const { onChange, pagination } = props;
  return (
    <InputGroup className="mb-3">
      <InputGroup.Prepend>
        <InputGroup.Text id="basic-addon1">Results Per Page</InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control
        required
        as="select"
        onChange={onChange}
        defaultValue={pagination.pageSize}
      >
        <option>10</option>
        <option>25</option>
        <option>50</option>
      </Form.Control>
    </InputGroup>
  );
};

PageSizeSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  pagination: Shapes.PAGINATION.isRequired,
};

export default PageSizeSelector;
